export let PathType = /*#__PURE__*/function (PathType) {
  PathType["DIRECTORY"] = "directory";
  PathType["FILE"] = "file";
  PathType["SYMLINK"] = "symlink";
  PathType["RESOURCE_FORK"] = "resource-fork";
  return PathType;
}({});
//# sourceMappingURL=types.mjs.map